import React from "react";
import { createRoot, type Root } from "react-dom/client";
import { StickersWindowLayout } from "./StickersWindowLayout";
import styles from "./stickersWindow.module.css";

export class StickersWindow {
    open() {
        this.stickersWindowWrapper = document.createElement("div");
        this.stickersWindowWrapper.classList.add(styles.stickersWindowOuter);

        document.body.appendChild(this.stickersWindowWrapper);

        this.root = createRoot(this.stickersWindowWrapper);
        this.render();
    }

    render() {
        const StickersWindowLayoutElement = React.createElement(StickersWindowLayout);

        if (this.root) {
            this.root.render(StickersWindowLayoutElement);
        } else {
            throw new Error("В StickersWindow отсутствует root");
        }
    }

    close() {
        this.root?.unmount();
        this.stickersWindowWrapper?.parentNode?.removeChild(this.stickersWindowWrapper);
    }

    stickersWindowWrapper: HTMLElement | null = null;
    root: Root | null = null;
}
